import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  navigate(event) {
    if (window.getSelection()?.toString().length > 0) return
    if (event.target.closest("a, button")) return
    window.location.href = this.urlValue
  }
}
